import * as React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from '@azure/msal-react';
import msalInstance from '../auth/msalConfig';
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { config } from "../config";

/* global document, Office, module, require, HTMLElement */

// Dynamically load Stella Bridge JS if configured
if (config.stellaAiBridgeJsUrl) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = config.stellaAiBridgeJsUrl;
  document.head.appendChild(script);
}

const title = "BuilderMetrix® Task Pane";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <MsalProvider instance={msalInstance}>
      <FluentProvider theme={webLightTheme}>
        <App title={title} />
      </FluentProvider>
    </MsalProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
